// Bump this whenever the policy text changes to re-trigger the acceptance gate for everyone.
export const CURRENT_POLICY_VERSION = '2026-08-16-2';

// Affiliate profile IDs exempted from the policy acceptance gate — they keep
// straight through to the dashboard even if they'd otherwise match the gate rules.
export const POLICY_EXEMPT_AFFILIATE_IDS = [
  '019d23c7-f514-4a96-be28-e076fa7bede9',
  '3c24cc85-c642-4ff5-8589-1ab0af1bd3e4'
];

export const isPolicyExemptAffiliate = (affiliateId?: string) =>
  !!affiliateId && POLICY_EXEMPT_AFFILIATE_IDS.includes(affiliateId);

export const POLICY_TITLE = 'شروط برنامج شركاء كالو';

export const POLICY_CONTENT = `
ياهلا وسهلا بشريكنا.. اللي تأثيره واصل لغيره 🚀

تُعد هذه السياسة جزءًا لا يتجزأ من اتفاقية الشراكة المبرمة بين شركة اللقمات المميزة لخدمات الإعاشة (شركة شخص واحد) والشريك.

ويُدار برنامج شركاء كالو بواسطة شركة اللقمات المميزة لخدمات الإعاشة (شركة شخص واحد)، ويخضع هذا البرنامج للشروط والأحكام الموضحة أدناه.

مرفق لك سياسة الانضمام والشروط الخاصة ببرنامج الأفيليت:

يتم تقديم وجبات صحية لكل شريك شهريًا باستخدام الرصيد المقدم له، بالإضافة إلى كود خصم خاص به وعمولة تسويقية، ويتم احتسابها بناءً على الفئات التالية:

الفئة التجريبية (لمدة أسبوع)
• اشتراك أسبوعي في باقة غداء العمل.
• عند تحقيق 3 اشتراكات خلال الأسبوع الأول، يتم تمديد الاشتراك لبقية الشهر.
• يحصل المسوق على نسبة 5% من عائد الاشتراكات وماركت كالو عبر الكود الخاص به.
• في حال عدم تحقيق 6 اشتراكات خلال الشهر الأول، تنتهي مدة التعاون ويتم إيقافه.

فئة C
• تحقيق من 6 إلى 10 اشتراكات في الشهر.
• إضافة رصيد وجبات بقيمة 1,000 ريال شهريًا في تطبيق كالو.
• يحصل المسوق على نسبة 5% من عائد الاشتراكات عند التجديد ومن ماركت كالو عبر الكود الخاص به، و10% من مبيعات المشتركين الجدد.
• كود خصم بنسبة 10% للمتابعين على جميع الباقات (ما عدا باقة 3 أشهر والباقة السنوية).

فئة B
• تحقيق من 11 إلى 24 اشتراكًا في الشهر.
• إضافة رصيد وجبات بقيمة 2,000 ريال شهريًا في تطبيق كالو.
• يحصل المسوق على نسبة 5% من عائد الاشتراكات وماركت كالو إذا كان العميل الذي استخدم الكود مشتركًا سابقًا لدى كالو وقام بتجديد اشتراكه باستخدام الكود، ونسبة 10% من المبيعات إذا كان العميل مشتركًا جديدًا.
• مكافأة مالية بقيمة 1,500 ريال، بشرط أن تكون الاشتراكات ناتجة عن مشتركين جدد لا يوجد لديهم تاريخ سابق من الاشتراكات لدى كالو.
• كود خصم بنسبة 10% للمتابعين على جميع الباقات (ما عدا باقة 3 أشهر والباقة السنوية).

فئة A
• تحقيق أكثر من 25 اشتراكًا شهريًا لمدة 3 أشهر متتالية.
• إضافة رصيد وجبات بقيمة 2,200 ريال شهريًا في تطبيق كالو.
• يحصل المسوق على نسبة 5% من عائد الاشتراكات وماركت كالو إذا كان العميل الذي استخدم الكود مشتركًا سابقًا لدى كالو وقام بتجديد اشتراكه باستخدام الكود، ونسبة 10% من المبيعات إذا كان العميل مشتركًا جديدًا.
• مكافأة مالية بقيمة 5,000 ريال، بشرط ألا يقل عدد الاشتراكات الجديدة (الاستحواذات) شهريًا عن الحد المطلوب لفئة A لمدة 3 أشهر متتالية.
• كود خصم بنسبة 10% للمتابعين على جميع الباقات (ما عدا باقة 3 أشهر والباقة السنوية).

شروط أساسية
في حال وجود رصيد وجبات سابق لدى المسوق ولم يتم استخدامه خلال الشهر السابق، فلن يتم إضافة رصيد جديد حتى يتم استهلاك الرصيد السابق بالكامل.

الإقرار والموافقة
بالنقر على زر "الموافقة" أو الانضمام إلى برنامج شركاء كالو، فإنك تقر بأنك قرأت وفهمت ووافقت على جميع الشروط والأحكام الواردة في هذه السياسة، كما توافق على أن تكون شركة اللقمات المميزة لخدمات الإعاشة (شركة شخص واحد) هي الجهة المنظمة والمشرفة على البرنامج.

وتحتفظ الشركة بحقها، وفقًا لتقديرها المطلق، في تعديل أو تحديث أو تعليق أو إيقاف أو مراجعة هذه السياسة أو برنامج شركاء كالو أو أي جزء منه في أي وقت، بما في ذلك – على سبيل المثال لا الحصر – العمولات، والحوافز، والمكافآت، وتصنيفات الفئات، وشروط الاستحقاق، وأرصدة الوجبات، وأكواد الخصم، وأي مزايا أو شروط أخرى مرتبطة بالبرنامج. ويتم إشعار الشريك بهذه التعديلات من خلال رسائل الواتساب (النصية أو الصوتية)، أو البريد الإلكتروني، أو من خلال التحديثات المنشورة عبر رابط تتبع الكود أو المنصة الخاصة بالشريك، وتُعد النسخة المنشورة أو المُبلّغ بها عبر أي من وسائل الإشعار المذكورة هي النسخة المعتمدة والنافذة، وتصبح التعديلات سارية اعتبارًا من تاريخ نشرها أو إشعار الشريك بها، ويُعد استمرار الشريك في البرنامج أو استخدامه بعد ذلك موافقةً صريحة منه على جميع التعديلات المحدثة.
`;
